import { request } from "../utils/http"
import { defer, Observable } from "rxjs"
import { map, retry } from "rxjs/operators"

export const logout = (headers: Record<string, any>): Observable<boolean> =>
    defer(() =>
        request({
            method: "POST",
            path: "/auth/logout",
            headers: headers,
        })
    ).pipe(
        retry(3),
        map(() => true)
    )
